import {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  getEpisodeWords,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
  updateEpisode,
} from "./episode.service";

export const episodeService = {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  getEpisodeWords,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
  updateEpisode,
};
